import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';

import { storageKeys } from 'settings';
import { APIHandler, DataHandler, StorageHandler, FavoriteLink, ContentHeader } from 'C4';

const getFavoriteContent = async (callback) => {
  const { response: user } = (await StorageHandler.load(storageKeys.user)) || {};

  if (user) {
    const { data: favorites } = (await APIHandler.getFavorite(DataHandler.matchAppIdSync(), user.email)) || {
      data: {},
    };

    const { pages } = (await APIHandler.getFavoriteContent(favorites)) || {};

    callback({ favorites, favoriteContent: pages });
  }
};

const FavoriteView = () => {
  const [{ favorites, favoriteContent }, setFavorites] = useState({ favorites: [], favoriteContent: [] });

  useEffect(() => {
    getFavoriteContent(setFavorites);
  }, []);

  return (
    <div className="contentContainer">
      <ContentHeader
        header={i18n.translate('nav.favorites')}
        subtitle={i18n.translate('pageDescriptions.favorites')}
        line
      />
      <div className="favorite__Container">
        {favorites.length === 0 && <p className="subtitle">{i18n.translate('general.noFavorites')}</p>}
        <div className="favorite__Grid">
          {favorites.map((info, i) => (
            <React.Fragment>
              {i.subType !== null && <FavoriteLink key={`${info.type}_${info.unid}`} {...info} content={favoriteContent[i]} />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FavoriteView;
